import { render } from "./EditGroupForm.vue?vue&type=template&id=1cf1dcc6&scoped=true"
import script from "./EditGroupForm.vue?vue&type=script&lang=js"
export * from "./EditGroupForm.vue?vue&type=script&lang=js"

import "./EditGroupForm.vue?vue&type=style&index=0&id=1cf1dcc6&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf1dcc6"]])

export default __exports__